import { createContext, useContext } from 'react';

export interface PlatformToastPreferenceContextValue {
    bodyExpandedByDefault: boolean;
    onBodyExpandedPreferenceChange?: (expanded: boolean) => void;
}

export const PlatformToastPreferenceContext = createContext<PlatformToastPreferenceContextValue>({
    bodyExpandedByDefault: true,
});

export const usePlatformToastPreferences = () => useContext(PlatformToastPreferenceContext);
